import React, { PureComponent } from 'react';
import { Field } from 'react-final-form';
import { getLocationApiErrorMessage, debounce, getAddressFromPlaces } from '../../utils/helper';
import { required } from '../../utils/validation';
import './GoogleAutoComplete.scss';
// fillInAddress is a callBack method to use when user select values from dropdown
// Use the arguments from fillInAddress it will have autoComplete object
// pass setRef for input box reference
// pass name for Field name
// Please use it inside React Final form as it is only a component

let spinnerClass; // eslint-disable-line
'#if CLIENT_TYPE === "desktop"'; // eslint-disable-line
spinnerClass = 'fa fa-spinner fa-spin';
'#endif'; // eslint-disable-line
'#if CLIENT_TYPE === "mobile"'; // eslint-disable-line
spinnerClass = 'icon-spinner animate-spin';
'#endif'; // eslint-disable-line

class GoogleAutoComplete extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            locationErrorMessage: '',
            locationProcessing: false
        };
        this.locationAddress = {};
        this.lat = '';
        this.lng = '';
        this.autoComplete = null;
        this.ref = React.createRef();
        this.onChange = debounce(this.onChange.bind(this), 300);
        this.isDropdownClick = false;
        this.isGpsIconClicked = false;
        this.keyPress = this.keyPress.bind(this);
    }
    componentDidMount() {
        this.initPlacesService();
        if (this.props.autoDetectLocation) {
            this.getLocation();
        }
    }
    componentDidUpdate(prevProps, prevState) {
        const { locationErrorHandler } = this.props;
        const {locationErrorMessage, locationProcessing } = this.state;
        if (locationErrorHandler && ((prevState.locationErrorMessage !== locationErrorMessage && locationErrorMessage) || (prevState.locationProcessing !== locationProcessing && locationProcessing))) {
            locationErrorHandler({ message: locationErrorMessage });
        }
    }
    onChange(formattedAddress, input) {
        const { onChange } = this.props;
        if (typeof onChange === 'function' && !this.isDropdownClick) onChange({ formattedAddress });
        this.isDropdownClick = false;
        this.isGpsIconClicked = false;
        input.onBlur();
    }
    getLocation() {
        const { mutators } = this.props;
        if ('geolocation' in window.navigator) {
            mutators.setFormattedAddress('');
            this.setState({
                locationProcessing: true,
                locationErrorMessage: ''
            });
            window.navigator.geolocation.getCurrentPosition(
                position => this.locationSuccess(position),
                error => this.locationError(error)
            );
        }
    }
    locationSuccess(position) {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        if (this.lat !== lat || this.lng !== lng) {
            const geocoder = new window.google.maps.Geocoder;
            const location = { lat, lng };
            /* eslint new-parens: 0 */
            geocoder.geocode({ location }, (results, status) => {
                if (status === 'OK') {
                    if (results[0]) {
                        this.lat = lat;
                        this.lng = lng;
                        this.locationAddress = results[0];
                        this.autoComplete.set('place', this.locationAddress);
                    } else {
                        console.log('No results found');
                    }
                } else {
                    console.log('Geocoder failed due to: ' + status);
                }
                this.setState({
                    locationProcessing: false,
                    locationErrorMessage: ''
                });
            });
        } else {
            this.autoComplete.set('place', this.locationAddress);
            this.setState({
                locationProcessing: false,
                locationErrorMessage: ''
            });
        }
    }
    locationError(error) {
        this.setState({
            locationProcessing: false,
            locationErrorMessage: getLocationApiErrorMessage(error)
        });
    }
    initPlacesService() {
        if (window.google && window.google.maps) {
            this.autoComplete = new window.google.maps.places.Autocomplete(this.ref.current, { types: ['geocode', 'establishment'] });
            this.autoComplete.setTypes(['geocode']);
            this.autoComplete.setFields(['address_components', 'formatted_address', 'geometry']); // , 'geometry' used for lat lng
            this.autoComplete.setComponentRestrictions({ country: ['in'] });
            this.autoComplete.addListener('place_changed', () => this.fillInAddress(this.autoComplete));
        } else {
            setTimeout(() => { this.initPlacesService(); }, 2000);
        }
    }
    fillInAddress(autoComplete) {
        this.isDropdownClick = true;
        const { mutators, fillInAddress } = this.props;
        const place = autoComplete.getPlace();
        mutators.setFormattedAddress(place.formatted_address || place.name);
        const address = getAddressFromPlaces(place);
        fillInAddress(address, this.isGpsIconClicked);
    }
    keyPress(input, e) {
        if (e.keyCode === 13) {
            this.onChange(input.value, input);
            this.ref.current.value = input.value;
            this.ref.current.blur();
        }
    }
    render() {
        const { locationErrorMessage, locationProcessing } = this.state;
        const { name, label, customInputClass = '', customClass = '', error, children, placeholder, customValidate } = this.props;
        const validate = customValidate || required;
        return (
            <Field name={name} validate={validate}>
                {({ input, meta }) => (
                    <div className="material-group">
                        <div className={`text-color_black google-input-wrapper ${customClass}`}>
                            <input ref={this.ref} className={customInputClass} placeholder={placeholder === undefined ? '' : placeholder} {...input} type="text" autoComplete="shipping address-line2" onKeyDown={e => this.keyPress(input, e)} onKeyUp={() => { this.isDropdownClick = false; }} onBlur={() => this.onChange(input.value, input)} />
                            {children}
                            {label && <label>{label}</label>}
                            <span className={`fa fa-crosshairs gps-location text-topaz fsp16 icon pd-t3 ${!locationProcessing ? 'icon-ic_gps_fixed padding-t3' : spinnerClass} pos-abs`} onClick={() => { this.isGpsIconClicked = true; if (!locationProcessing) this.getLocation(); }}></span>
                        </div>
                        <div className="google-autocomplete-error-container">
                            {locationErrorMessage && !input.value ? <span className="text-color_brick_red fsp10 fs10">{locationErrorMessage}</span> : <span className="text-color_brick_red fs10 fsp12">{meta.error && meta.touched ? meta.error : ''}</span>}
                            {error && input.value && <span className="text-color_brick_red fsp12 fs10">{error}</span>}
                        </div>
                    </div>
                )}
            </Field>
        );
    }
}
export default GoogleAutoComplete;
